<template>
  <div>
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>重置密码</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="10" :offset="2">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="resetPass" label-position="right" size="small" label-width="200px">
          <el-form-item label="原始密码：" prop="oldPwd">
            <el-input v-model.trim="form.oldPwd"></el-input>
          </el-form-item>
          <el-form-item label="设置密码：" prop="newPwd"  v-if="visible">
            <el-input  v-model.trim="form.newPwd" type="password" show-password ></el-input>
          </el-form-item>
          <el-form-item label="重复密码：" prop="confirmPwd">
            <el-input v-model.trim="form.confirmPwd" type="password" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit" :disabled = 'saveBtnStatue'>提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import { validateEnCompany } from '@/utils/validator'
import tools from '../utils/tools.js';
export default {
  data: () => ({
    saveBtnStatue:false,  //保存铵钮状态
    visible:true,
    form: {
     oldPwd:"",
     newPwd:"",
     confirmPwd:""
    },
    rules: {
      oldPwd: [{ required: true, message: '请填写原始密码', trigger: 'change' }],
      newPwd: [{ required: true, message: '请填写新密码', trigger: 'change' }],
      confirmPwd: [{ required: true, message: '请确认新密码', trigger: 'change' }],
    },
    buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
  }),


  components: {},
  mounted() {
  },
  methods: {

    onSubmit(){
        if( this.saveBtnStatue ){
          return false
        }
        this.$refs['resetPass'].validate((valid) => {
          if (valid) {

              if(this.form.newPwd != this.form.confirmPwd ){
                  this.$notify({
                    title: '警告',
                    message: '两次填写密码不一致！',
                    type: 'warning',
                    duration: 2000
                  });
                  return false
              }
              this.saveBtnStatue = true
              api.updateactorpwd(this.form).then((res) => {
                if (res.data.code === 200) {
                  this.$notify({
                    title: '修改成功',
                    type: 'success',
                     duration: 2000
                  })
                }
                this.saveBtnStatue = false
              })
          } else {
            this.$notify({
              title: '请检查表单填写项是否符合规范！',
              type: 'error'
            })
            return false
          }
        })
    }
  }
}
</script>
<style lang="less">

</style>
